import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isHoveringClickable: false
};

const hoverSlice = createSlice({
  name: 'hover',
  initialState,
  reducers: {
    setHoveringClickable: (state, action) => {
      state.isHoveringClickable = action.payload;
    }
  }
});

export const { setHoveringClickable } = hoverSlice.actions;

// Selectors
export const selectIsHoveringClickable = (state) => state.hover.isHoveringClickable;

export default hoverSlice.reducer;
